import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import Popup from "components/WMS/Mobile/Popup";
import CustomButton from "components/CustomButton";
import BoxGrouped from "assets/img/wms/boxGrouped.svg";
import {WMSContext} from "../../../../context/WMSContext";

ShipPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    totalShipments: PropTypes.number,
};

function ShipPopup({open = true, handleClose = () => {}, onClick = () => {}, totalShipments}) {
    const {currentOrganization} = useContext(WMSContext)
    const [loading, setLoading] = useState(false)
    
    if (!totalShipments) {
        return null;
    }

    const Icon = () => (
        <img
            src={BoxGrouped}
            alt='Refresh'
            style={{
                width: '63px',
                height: '78px',
            }}
        />
    );

    return (
        <Popup
            title={(<FormattedMessage id='wms.shipping.popup.title' />)}
            subtitle={(
                <FormattedMessage
                    id={totalShipments === 1 ? 'wms.shipping.popup.subtitle.single' : 'wms.shipping.popup.subtitle'}
                    values={{count: totalShipments}}
                />
            )}
            open={open}
            onClose={handleClose}
            icon={<Icon />}
        >
            <Grid container>
                <Grid
                    container
                    item
                    direction={"column"}
                    gap={2}
                >
                    <CustomButton
                        onClick={() => {
                            setLoading(true)
                            onClick()
                        }}
                        fullWidth={true}
                        disabled={loading}
                    >
                     {currentOrganization?.printExpeditionList
                         ? <FormattedMessage id={'wms.shipping.popup.action.shipAndPrint'} />
                         : <FormattedMessage id={totalShipments === 1 ? 'wms.shipping.popup.action.ship.single' : 'wms.shipping.popup.action.ship'} />
                     }
                    </CustomButton>
                    <CustomButton
                        onClick={handleClose}
                        color={'default'}
                        fullWidth={true}
                    >
                        <FormattedMessage id='wms.shipping.popup.action.cancel' />
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default ShipPopup;
